import { TPlatform } from '../../types/platform';

export const getPlatformFromUserAgent = (userAgent: string): TPlatform => {
  const isMobile = /mobile|iphone|ipad|ipod|android|blackberry|mini|windows\sce|palm/i.test(userAgent);

  if (/iPad/i.test(userAgent) || /iPhone/i.test(userAgent)) {
    return 'ios';
  } else if (/Android/i.test(userAgent)) {
    return 'android';
  }

  if (!isMobile) {
    return 'desktop';
  }

  return 'other';
};
